import { Divider } from "primereact/divider";
import { Tree } from "primereact/tree";

import "./style.scss";

const ListMenu = ({ items, onSelect, activeKey, expandedKeys, setExpandedKeys }) => {
    const handleNodeSelect = (e) => {
        if (e.node.children) return;
        const parts = e.node.key.split("-");
        const newExpanded = parts.length > 1 ? { [parts[0]]: true } : {};
        setExpandedKeys(newExpanded);
        onSelect(e, e.node);
    };

    const handleToggle = (e) => {
        const value = e?.value || { [e.node.key]: true };
        const newKeys = Object.keys(value);
        const oldKeys = Object.keys(expandedKeys);
        const openedKeys = newKeys.find((key) => !oldKeys.includes(key));

        setExpandedKeys(openedKeys ? { [openedKeys]: true } : {});
    };

    const highlightActive = (items) =>
        items.map((item) => {
            const result = {
                ...item,
                className: item.key === activeKey ? "active" : "",
            };
            if (item.children) {
                result.children = highlightActive(item.children);
            }
            return result;
        });
    const nodeTemplate = (node, options) => (
        <div className={[options.className, node.children ? "tree-node-only-toggle" : ""].filter(Boolean).join(" ")} onClick={options.onClick}>
            {node.label}
        </div>
    );

    return (
        <div className="list-menu">
            {items.map((i, idx) => {
                return i?.type === "divider" ? (
                    <Divider key={idx} />
                ) : (
                    <Tree value={highlightActive(i)} key={idx} selectionMode="single" expandedKeys={expandedKeys} onSelect={handleNodeSelect} onToggle={handleToggle} onNodeClick={handleToggle} nodeTemplate={nodeTemplate} />
                );
            })}
        </div>
    );
};

export default ListMenu;
